exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-e8f96564] {\n  justify-content: space-between;\n  padding-left: 10px;\n  padding-right: 20px;\n  margin: 16px 0;\n  border-radius: 5px;\n}\n.content[data-v-e8f96564] {\n  width: 930px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.content div[data-v-e8f96564]:first-child {\n  margin-right: 20px;\n}\n", ""]);

// exports
